module.exports = __webpack_public_path__ + "img/1320175247.04a54ff5.jpg";